import React from 'react';
import PropTypes from 'prop-types';
import './listAssign.less';
import { Translate } from '@above-the-treeline/localization';
import paths from '../../../../paths';
import { Link } from 'react-router-dom';

ListTitleIsOnBullet.propTypes = {
	list: PropTypes.object,
	communityName: PropTypes.string,
};

function ListTitleIsOnBullet({ list, communityName }) {
	const getCommunityName = () =>
		communityName ? (
			<span>
				({communityName} <Translate id="community" />)
			</span>
		) : null;
	return (
		<div className="current-list">
			<div className="icon-single" />
			<Link
				to={paths.collaborativeList(list.id)}
				className="column-spaced dotDot collaborative-list-title">
				{list.name} {getCommunityName()}
			</Link>
			<div className="clear" />
		</div>
	);
}

export default ListTitleIsOnBullet;
